import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { InduccionEstado, ParametrosMaestro } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { FilterInduccionModel } from 'src/app/models/induccion/FilterInduccionModel';
import { InduccionResultadoBusquedaModel } from 'src/app/models/induccion/InduccionResultadoBusquedaModel';
import { IFilterInduccionModel } from 'src/app/models/interfaces/induccion/IFilterInduccionModel';
import { IInduccionResultadoBusquedaModel } from 'src/app/models/queries/inducciones/interfaces/IInduccionResultadoBusquedaModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { InduccionService } from 'src/app/services/induccion/induccion.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import * as fileSaver from 'file-saver';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-induccion-lista',
  templateUrl: './induccion-lista.component.html',
  styleUrls: ['./induccion-lista.component.css']
})
export class InduccionListaComponent implements OnInit {
  modelFilter: IFilterInduccionModel;
  modelListaInducciones: IInduccionResultadoBusquedaModel[];
  resultsLength = 0;
  currentPage = 0;
  @ViewChild('paginator') paginator!: MatPaginator;
  listaEstadoInducciones: ParametroModel[];

  displayedColumns: string[] = [
    'codigo_solicitud',    
    'compania',
    'sede',
    'trabajador',
    'nroDocumentoIdentidad',
    // 'fecha_aprobacion',
    'fecha_induccion',
    'estado',    
    //'acciones',
  ];

  constructor(
    private induccionService: InduccionService,
    private parametroService: ParametroService,
    private storage: StorageService,
  ) { 
    this.modelFilter = new FilterInduccionModel();
    this.modelFilter.pageSize = 30;    
    this.modelFilter.estados = [InduccionEstado.PROGRAMADO, InduccionEstado.APROBADO, InduccionEstado.RECHAZADO, InduccionEstado.VENCIDO, InduccionEstado.SUSPENDIDO];
    this.modelListaInducciones = new Array<InduccionResultadoBusquedaModel>();
    this.listaEstadoInducciones = new Array<ParametroModel>();
  }

  ngOnInit(): void {
    this.induccionService
      .getList(this.modelFilter)
      .subscribe((data: SearchResultModel<IInduccionResultadoBusquedaModel[]>) => {
        this.modelListaInducciones = data.items;
        this.resultsLength = data.total;
      });

    this.parametroService
      .getDetalles(ParametrosMaestro.EstadosInducciones)
      .subscribe((data: SearchResultModel<ParametroModel[]>) => {
        this.listaEstadoInducciones = data.items.filter(p => p.idParametroDetalle != InduccionEstado.EMPTY && p.idParametroDetalle != InduccionEstado.PENDIENTE)
      });
  }
  
  getPaginatorData(event: any) {
    this.modelFilter.page = event.pageIndex + 1;
    this.modelFilter.pageSize = event.pageSize;
    this.induccionService
      .getList(this.modelFilter)
      .subscribe((data: SearchResultModel<IInduccionResultadoBusquedaModel[]>) => {
        this.modelListaInducciones = data.items;
        this.resultsLength = data.total;
      });
  }

  search() {
    //this.paginator.pageIndex = 0;
    this.modelFilter.page = 1;
    // this.model.pageSize = this.paginator.pageSize;
    this.induccionService
      .getList(this.modelFilter)
      .subscribe((data: SearchResultModel<IInduccionResultadoBusquedaModel[]>) => {
        this.modelListaInducciones = data.items;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }  

  addDays(currentDate: Date, days : number): Date{
    currentDate.setDate(currentDate.getDate() + days);
    return currentDate;
  }

  export() {
    //this.paginator.pageIndex = 0;
    this.modelFilter.page = 1;
    // this.model.pageSize = this.paginator.pageSize;
    this.induccionService.getListToContratistaExport(this.modelFilter).subscribe(
      (data) => {
        // console.log(data.headers.get('content-disposition'));
        // console.log(data.headers);
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        const url = window.URL.createObjectURL(blob);

        //window.open(url);
        //window.location.href = response.url;
        fileSaver.saveAs(blob, `inducciones-${Date.now()}.xlsx`);

        //  this.createImageFromBlob(data);
        //  this.isImageLoading = false;
      },
      (error) => {
        //  this.isImageLoading = false;
        //  console.log(error);
      }
    );
  }
}
